import { Controller } from 'stimulus';
import ls from 'local-storage';
import htmldiff from 'htmldiff-js/src/Diff';

const HIGHLIGHTER_KEY = 'highlighter-enabled';

export default class extends Controller {
  static targets = ['button'];

  connect() {
    this.disabled = true;
    ls.backend(sessionStorage);
    if (this.locked) {
      this.update();
      return;
    }
    if (!this.cache) {
      this.update();
      this.cache = this.html;
      return;
    }
    if (this.cache === this.html) {
      this.update();
      return;
    }

    this.lock();
    const { html } = this;
    this.disabled = false;
    if (this.active) this.html = this.diff;
    this.cache = html;
    this.updateButton();
  }

  lock() {
    this.data.set('locked', 'true');
  }

  get active() { // eslint-disable-line class-methods-use-this
    return ls.get(HIGHLIGHTER_KEY);
  }

  set active(value) { // eslint-disable-line class-methods-use-this
    ls.set(HIGHLIGHTER_KEY, value);
    this.updateButton();
  }

  updateButton() {
    if (!this.hasButtonTarget) return;
    if (this.disabled) {
      this.buttonTarget.setAttribute('disabled', 'disabled');
      this.buttonTarget.classList.toggle('btn-outline-dark', false);
      this.buttonTarget.classList.toggle('btn-outline-warning', false);
      this.buttonTarget.classList.toggle('btn-outline-primary', false);
    } else {
      this.buttonTarget.classList.toggle('btn-outline-dark', false);
      this.buttonTarget.classList.toggle('btn-outline-warning', this.active);
      this.buttonTarget.classList.toggle('btn-outline-primary', !this.active);
      this.buttonTarget.removeAttribute('disabled');
    }
  }

  toggle() {
    if (this.disabled) return;

    this.html = this.cache;
    this.active = !this.active;
  }

  get locked() {
    return this.data.get('locked') === 'true';
  }

  get key() {
    return this.data.get('key') || window.location.href.split('#')[0];
  }

  get cache() {
    return ls.get(this.key);
  }

  set cache(value) {
    ls.set(this.key, value);
  }

  get html() {
    return this.element.innerHTML;
  }

  set html(value) {
    this.element.innerHTML = value;
    Array.from(this.element.querySelectorAll('textarea')).forEach((textarea) => {
      textarea.innerHTML = textarea.innerHTML.replace(/&lt;del.*?&lt;\/del&gt;/g, '').replace(/&lt;ins.*?&gt;/g, '').replace(/&lt;\/ins&gt;/g, '').trim();
    });
    this.update();
  }

  get diff() {
    this.diffCache = this.diffCache || htmldiff.execute(this.cache, this.html);
    return this.diffCache;
  }

  update() {
    this.updateButton();
  }
}
